const STORAGE_KEY = 'originalReferral';

/**
 * This script is supposed to be called in the <head> element of all apps with widget.
 * It stores the inital(original) referrer url from headers for later use in the widget payload.
 * -
 * The document.referrer is an empty string if the user navigated to the page directly (not through a link).
 * Then during internal navigation, links should not be considered as referrers.
 */
export function SaveOriginalReferralScript() {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          (function() {
            if (!sessionStorage.getItem("${STORAGE_KEY}")) {
              const referrer = document.referrer;
              if (referrer && !referrer.includes(window.location.hostname)) {
                sessionStorage.setItem("${STORAGE_KEY}", referrer);
              }
            }
          })();
        `,
      }}
      type="text/javascript"
      key="save-original-referral-script"
    />
  );
}

export function getOriginalReferral(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return sessionStorage.getItem(STORAGE_KEY) || undefined;
}
